export default __webpack_public_path__ + "5c4f071889fa0cf8119340a5705f3521.svg";